export default function MMGraficoPainel({ media, fullName, nomeAgrupador }) {
    return `${fullName} não possui gráfico`
}